'use client';

import { SupportData } from '@/shared/types/layers/domain/entities/customer/support/support-data';
import moment from 'moment';
import { FC, useState } from 'react';
import { twJoin } from 'tailwind-merge';

type SupportItemProps = {
  subject: string;
  protocol: string | number;
  createdAt: number;
  support: SupportData;
};

export const SupportItem: FC<SupportItemProps> = ({
  subject,
  protocol,
  createdAt,
  support,
}) => {
  let [isOpen, setIsOpen] = useState(false);

  function open() {
    setIsOpen(true);
  }

  function close() {
    setIsOpen(false);
  }

  return (
    <>
      <div
        className={twJoin(
          'py-5 outline-none',
          'transition-all duration-300',
          // 'hover:translate-x-1 hover:bg-black hover:bg-opacity-5',
          // 'focus:translate-x-1 focus:bg-black focus:bg-opacity-5',
        )}
        onClick={() => open()}
      >
        <div className="flex">
          <span className="text-md font-bold">{subject.replaceAll('PLINT', '')}</span>
        </div>
        <div className="mt-2 flex">
          <span className="text-md text-gray-600">
            <span className="hidden sm:inline">Protocolo - </span>
            {protocol}
          </span>
          <span className="text-md ml-auto text-gray-600">
            {/* TODO: No servidor, passar um campo com a data já formatada */}
            {moment.unix(createdAt).utc().format('DD/MM/YYYY')}
          </span>
        </div>
      </div>
      {/* <Dialog
        open={isOpen}
        as="div"
        className="relative z-30 focus:outline-none"
        onClose={close}
        __demoMode
      >
        <div className="fixed inset-0 z-30 w-screen overflow-y-auto bg-black/50">
          <div className="flex min-h-full items-center justify-center p-4">
            <DialogPanel
              transition
              className="data-[closed]:transform-[scale(95%)] w-full max-w-md rounded-xl bg-white p-6 backdrop-blur-2xl duration-300 ease-out data-[closed]:opacity-0"
            >
              <DialogTitle as="h3" className="text-base/7 font-medium">
                Detalhes
              </DialogTitle>
              <div className="mt-2 flex flex-row gap-2 text-sm/6">
                <span className="font-semibold">Protocolo:</span>
                <span>{support.protocol}</span>
              </div>
              <div className="mt-2 flex flex-row gap-2 text-sm/6">
                <span className="font-semibold">Status:</span>
                <span>
                  {support.status === 'CLOSED' ? 'Fechado' : 'Aberto'}
                </span>
              </div>
              <div className="mt-2 flex flex-row gap-2 text-sm/6">
                <span className="font-semibold">Assunto:</span>
                <span>{support.subject}</span>
              </div>
              <div className="mt-4">
                <Button
                  id="button-close-support-dialog"
                  color="secondary"
                  onClick={close}
                >
                  Fechar
                </Button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog> */}
    </>
  );
};
